<template>
    <v-container>
        <v-row class="my-2 subtitle-2 secondary--text pl-12">
            PROFESSOR Profile
        </v-row>
        <div v-if="user" class="body-2">
            <v-row justify="end">
                <v-btn color="secondary" class="text-capitalize mt-4" plain @click="logOut()">
                    <v-icon>mdi-logout</v-icon>
                    {{ 'log Out' | localize }}
                </v-btn>
            </v-row>
            <v-row>Name: {{ user.name }}</v-row>
            <v-row>Email: {{ user.email }}</v-row>
            <v-row>Role: {{ user.role }}</v-row>
            <v-divider class="my-4"></v-divider>
            <v-row>Country: {{ promo?.institute?.country }}</v-row>
            <v-row>City: {{ promo?.institute?.city }}</v-row>
            <v-row>Organization: {{ promo?.institute?.name }}</v-row>
            <v-row>Faculty: {{ promo?.institute?.faculty }}</v-row>
            <v-row v-if="promo?.institute?.date_expired">date of the promo code expiration: {{ dateToString(promo.institute.date_expired) }}</v-row>
            <v-divider class="my-4"></v-divider>
        </div>
    </v-container>
</template>

<script>
import { ConvertDateToString } from '../../functions/common';
export default {
    name: 'Profile',
    data() {
        return {
        }
    },
    computed: {
        user() {
            return this.$store.getters.user;
        },
        promo() {
            console.log(this.$store.getters.promo)
            return this.$store.getters.promo;
        },
        locale() {
            return this.$store.getters.locale;
        }
    },
    watch: {
        user() {
            if (!this.user) {
                this.$router.push('/');
            }
        }
    },
    methods: {
        dateToString(date) {
            return ConvertDateToString(date, this.locale);
        },
        async logOut() {
            try {
                await this.$store.dispatch('logout', this.user.id);
            }
            catch (error) {
                console.log(error.message)
            }
        }
    },
    components: {},
    async mounted() {
        if (this.user && this.user.promoId) {
            const id = this.user.promoId;
            try{
                this.$store.dispatch('fetchPromo', id)
            }
            catch(error) {
                console.log(error.message)
            }
        }
     }
}
</script>